import styled, { css } from 'styled-components';

interface ContentProps {
  isFocused: boolean;
  isFilled: boolean;
  isErrored: boolean;
  isDisabled: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  color: var(--cinza-escuro-5bits);

  label {
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.1rem;
    text-align: center;
  }
`;

export const Content = styled.div<ContentProps>`
  background: var(--input-bg-color);
  border-radius: 1.2rem;
  border: 1px solid var(--input-border-color);

  padding: 0.5rem;
  width: 100%;
  /* height: 10rem;
  min-height: 10rem; */
  color: var(--input-text-color);

  display: flex;
  align-items: flex-start;
  justify-content: center;

  & + div {
    margin-top: 8px;
  }

  ${props =>
    props.isDisabled &&
    css`
      filter: brightness(0.9);

      &:hover {ssssssss
        filter: brightness(0.9);
      }
    `}

  ${props =>
    props.isErrored &&
    css`
      border-color: var(--on-errored-input-border-color);
    `}

  ${props =>
    props.isFocused &&
    css`
      color: var(--on-focus-input-text-color);
      border-color: var(--on-focus-input-border-color);
    `}

  ${props =>
    props.isFilled &&
    css`
      color: var(--on-filled-input-text-color);
      border-width: 1px;
    `}


  textarea {
    flex: 1;
    width: 100%;
    height: 8.8rem;
    position: relative;
    min-height: 8.8rem;
    background-color: var(--input-bg-color);
    border: 0;
    padding: 1.2rem;

    ${props =>
      (props.isDisabled &&
        css`
          color: var(--cinza-claro-5bits);
          font-weight: 500;
        `) ||
      css`
        color: var(--input-text-color);
        font-weight: 500;
      `}

    &::placeholder {
      color: var(--input-placeholder-color);
    }

    &:disabled {
      cursor: not-allowed;
    }
  }

  svg {
    margin-right: 16px;
  }
`;

export const Error = styled.div`
  margin: 0 1.6rem 1.6rem;
  align-self: flex-start;
  color: var(--on-errored-message-bg-color);

  display: flex;
  align-items: flex-start;
  justify-content: center;

  svg {
    margin-right: 0.5rem;
  }

  span {
    background: var(--on-errored-message-bg-color);

    &::before {
      border-color: var(--on-errored-message-border-color) transparent;
    }
  }
`;
